import { FileUploadReview } from '@modules/fileUploadReview/components/FileUploadReview';
import { Box, Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { ReactElement, Ref, forwardRef } from 'react';

interface FileUploadReviewOpts {
  fileURL: string | undefined;
  fileName: string;
  integrationID: string;
}

interface FileUploadReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFileSelect: (file: File | undefined) => void;
  fileUploadReviewOpts: FileUploadReviewOpts;
}

const TransitionComponent = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const FileUploadReviewModal = ({
  isOpen,
  onClose,
  fileUploadReviewOpts,
  onFileSelect,
}: FileUploadReviewModalProps) => {
  if (!fileUploadReviewOpts.fileURL) {
    return null;
  }

  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onClose}
      TransitionComponent={TransitionComponent}
      PaperProps={{
        elevation: 0,
      }}
    >
      <Box py={2} px={5}>
        <FileUploadReview
          {...fileUploadReviewOpts}
          fileURL={fileUploadReviewOpts.fileURL}
          onClose={onClose}
          onFileSelect={onFileSelect}
        />
      </Box>
    </Dialog>
  );
};
